import DOMPurify from "dompurify";

const purify = DOMPurify.sanitize;

// Add target and rel to allowed attributes
DOMPurify.setConfig({
  ADD_ATTR: ["target", "rel"],
});

// Secure target="_blank" with rel="noopener noreferrer"
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    const rel = node.getAttribute("rel");
    if (!rel || !rel.includes("noopener")) {
      node.setAttribute("rel", "noopener noreferrer");
    }
  }
});

// Sanitize HTML
export const sanitizeHTML = (html) => {
  return purify(html);
};
